<template>
  <span :class="['checkpoint-quiz-badge', `checkpoint-quiz-badge--${displayState}`]">
    {{ displayText }}
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  quizMode: {
    type: String,
    required: true,
    validator: (value) => ["BOTH_REQUIRED", "SKIP_INSPECTION", "SKIP_QUIZ"].includes(value),
  },
  questionsCount: {
    type: Number,
    required: true,
  },
  hasMicrolearning: {
    type: Boolean,
    required: true,
  },
});

const displayState = computed(() => {
  if (!props.hasMicrolearning) return "inspector-only";
  if (props.quizMode === "SKIP_QUIZ") return "skipped";
  if (props.quizMode === "BOTH_REQUIRED" && props.questionsCount === 0) return "error";
  return "questions";
});

const displayText = computed(() => {
  if (displayState.value === "inspector-only") return "—";
  if (displayState.value === "skipped") return "Skipped";

  const questionLabel = props.questionsCount === 1 ? "Question" : "Questions";
  return `${props.questionsCount} ${questionLabel}`;
});
</script>

<style scoped>
.checkpoint-quiz-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  pointer-events: none;
  cursor: default;
  user-select: none;
}

.checkpoint-quiz-badge--questions,
.checkpoint-quiz-badge--skipped,
.checkpoint-quiz-badge--error {
  padding: var(--spacing-xxs, 2px) var(--spacing-md, 8px);
  border: 1px solid;
  border-radius: 9999px;
}

.checkpoint-quiz-badge--questions {
  color: var(--component-colors-utility-brand-utility-brand-700, #6941c6);
  background: var(--component-colors-utility-brand-utility-brand-50, #f9f5ff);
  border-color: var(--component-colors-utility-brand-utility-brand-200, #e9d7fe);
}

.checkpoint-quiz-badge--skipped {
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
  background: var(--component-colors-utility-gray-utility-gray-50, #f9fafb);
  border-color: var(--component-colors-utility-gray-utility-gray-200, #eaecf0);
}

.checkpoint-quiz-badge--error {
  color: var(--component-colors-utility-error-utility-error-700, #b42318);
  background: var(--component-colors-utility-error-utility-error-50, #fef3f2);
  border-color: var(--component-colors-utility-error-utility-error-200, #fecdca);
}

.checkpoint-quiz-badge--inspector-only {
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
}
</style>
